import * as React from "react"
import Svg, { Circle, Path } from "react-native-svg"

function StepCompleteIcon(props: any) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            {...props}
        >
            <Circle
                cx={16}
                cy={16}
                r={14}
                fill="#fff"
                stroke="#EBF2FF"
                strokeWidth={4}
            />
            <Path
                d="M11 15.88L13.918 19 22 13"
                stroke="#2D57D9"
                strokeWidth={1.5}
                strokeLinecap="round"
            />
        </Svg>
    )
}

export default StepCompleteIcon
